module.exports = __webpack_public_path__ + "static/badge_most_review-c8822dcb544880ff982a3271fecdfca6.gif";